import DialogMemberShareData from '~/components/family/dialog/DialogMemberShareData.vue';

export const useActionDialogFamilyNewMember = () => {
  const { onPlay, complete } = useAbstractAction(
    'actionDialogFamilyNewMember',
    false
  );

  const profile = useProfileStore();

  const dialog = useDialogStore();

  onPlay(async () => {
    if (profile.hasNewChildSharingData) {
      const newSharingDataMember = profile.shiftNewChildrenSharingData();
      dialog.open(DialogMemberShareData, {
        member: newSharingDataMember,
        onClose: () => {
          complete(true);
        },
      });
    } else {
      complete(false);
    }
  });
};
